import { useTranslation } from 'next-i18next';
// eslint-disable-next-line no-restricted-imports
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import {
    StyledCollectionDesc,
    StyledCollectionWrapper,
    StyledGifWrapper,
    StyledImageWrapper,
    StyledSecondSectionTitle,
    StyledThirdSectionTitle,
} from 'src/features/white-labels/nftsuperlab/universe/components/latest-collections/styles';
import { useScreenDetect } from 'src/hooks/useScreenDetect';
import { Button } from 'src/ui/common/atoms/button';
import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { Grid } from 'src/ui/common/atoms/grid';
import { Spacing } from 'src/ui/common/atoms/spacing';
import { Typography } from 'src/ui/common/atoms/typography';
import { Visible } from 'src/ui/common/layouts/visible';

export const LatestCollections: React.VFC<{ title?: string }> = ({ title }) => {
    const { t } = useTranslation(['pages', 'components']);
    const screen = useScreenDetect();
    const router = useRouter();
    const isQueryEmpty = Object.keys(router.query).length === 0;
    const { scrollTo } = router.query;

    useEffect(() => {
        if (!isQueryEmpty && scrollTo === 'the-collection') {
            document.querySelector('[data-component-id="the-collection"]')?.scrollIntoView();
        }
    }, []);

    return (
        <>
            <StyledCollectionWrapper data-component-id="the-collection">
                <Spacing padding="80px 0 40px">
                    <Spacing margin="0 0 30px">
                        <FlexBox alignItems="center" justifyContent="space-between">
                            <Typography variant="title" size={screen.xs || screen.sm ? 'base' : 'md'} color="white">
                                {title || t('home.widgets.latestCollections.title')}
                            </Typography>
                        </FlexBox>
                    </Spacing>
                    <Grid xs={2} sm={3} rowGap={35} columnGap={21}>
                        <StyledImageWrapper>
                            <Image src="/whitelabel/nftsuperlab/cc1.jpg" width={386} height={500} />
                        </StyledImageWrapper>
                        <StyledImageWrapper>
                            <Image src="/whitelabel/nftsuperlab/cc2.jpg" width={386} height={500} />
                        </StyledImageWrapper>
                        <StyledImageWrapper>
                            <Image src="/whitelabel/nftsuperlab/cc3.jpg" width={386} height={500} />
                        </StyledImageWrapper>
                        <StyledImageWrapper>
                            <Image src="/whitelabel/nftsuperlab/cc4.jpg" width={386} height={500} />
                        </StyledImageWrapper>
                        <StyledImageWrapper>
                            <Image src="/whitelabel/nftsuperlab/cc5.jpg" width={386} height={500} />
                        </StyledImageWrapper>
                        <StyledImageWrapper>
                            <Image src="/whitelabel/nftsuperlab/cc6.jpg" width={386} height={500} />
                        </StyledImageWrapper>
                    </Grid>
                    <Spacing margin="54px 30px">
                        <StyledCollectionDesc>
                            Kollektionen er baseret på seks historier og består af 2000 unika kunstværker. Vi holder
                            fast i mystikken omkring kunsten. Den NFT man køber er random valgt af vores system.
                        </StyledCollectionDesc>
                        <FlexBox justifyContent="center">
                            <Visible view={['laptop', 'desktop']}>
                                <Link href="https://discord.gg/wxMqPyAUvY" prefetch={false}>
                                    <a target="_blank">
                                        <Button variant="outline">Tilmeld dig Discord</Button>
                                    </a>
                                </Link>
                            </Visible>
                        </FlexBox>
                        <Visible view={['mobile']}>
                            <Link href="https://discord.gg/wxMqPyAUvY" prefetch={false}>
                                <a target="_blank">
                                    <Button variant="outline" stretch>
                                        Tilmeld dig Discord
                                    </Button>
                                </a>
                            </Link>
                        </Visible>
                    </Spacing>
                </Spacing>
            </StyledCollectionWrapper>
            <StyledCollectionWrapper>
                <Spacing padding="80px 0 40px">
                    <StyledSecondSectionTitle>
                        Hver NFT inkluderer en fysisk unika plakat, som man får tilsendt.
                    </StyledSecondSectionTitle>
                    <div>
                        <Image src="/whitelabel/nftsuperlab/cc7.jpg" width={1216} height={811} />
                    </div>
                </Spacing>
                <Spacing padding="40px 0 80px">
                    <StyledThirdSectionTitle>
                        De første 100 NFT købere får adgang til launch party med Casper Christensen d. 14 april på
                        klubben Museo.
                    </StyledThirdSectionTitle>
                    <StyledGifWrapper>
                        <Image src="/whitelabel/nftsuperlab/cc-gif.gif" width={756} height={516} />
                    </StyledGifWrapper>
                </Spacing>
            </StyledCollectionWrapper>
            <Spacing padding="80px 0 40px">
                <StyledThirdSectionTitle>
                    De første 250 NFT købere får lov til at møde og få signeret deres plakat af Casper Christensen.
                </StyledThirdSectionTitle>
                <FlexBox justifyContent="center">
                    <Link href="https://discord.gg/wxMqPyAUvY" prefetch={false}>
                        <a target="_blank">
                            <Button variant="outline">Tilmeld dig Discord</Button>
                        </a>
                    </Link>
                </FlexBox>
            </Spacing>
        </>
    );
};
